/**
 * Centralized helper for marking profile selection as complete.
 * Dispatches a custom event so all listeners (AuthProvider, AppFlowContext)
 * can react immediately — the native `storage` event only fires cross-tab.
 */

const PROFILE_SELECTION_EVENT = 'profile-selection-complete';

export function markProfileSelectionComplete() {
  sessionStorage.setItem('profile-selection-shown', 'true');
  window.dispatchEvent(new CustomEvent(PROFILE_SELECTION_EVENT));
}

export function onProfileSelectionComplete(callback: () => void): () => void {
  window.addEventListener(PROFILE_SELECTION_EVENT, callback);
  return () => window.removeEventListener(PROFILE_SELECTION_EVENT, callback);
}
